import { Button, Container, OverlayTrigger, Tooltip } from "react-bootstrap";
import { controlla, proposte } from '../../../utilities/icone'

export default function AzioniTabella(props) {

    const handleClick = (gestisci) => {
        props.setMostraTabella(false)
        props.setIniId(props.iniId)
        props.setGestisci(gestisci)
    }

    return (
        <Container className="d-flex justify-content-around p-0 m-0">
            <OverlayTrigger
                placement="bottom"
                overlay={<Tooltip>Controlla</Tooltip>}
            >
                <Button
                    variant="noBackground"
                    onClick={() => { handleClick("controlla") }}
                >
                    {controlla}
                </Button>
            </OverlayTrigger>
            <OverlayTrigger
                placement="bottom"
                overlay={<Tooltip>Progetti</Tooltip>}
            >
                <Button
                    variant="noBackground"
                    onClick={() => { handleClick("progetti-elenco") }}
                >
                    {proposte}
                </Button>
            </OverlayTrigger>
        </Container >
    )
}